import { render } from "./CategoryGroupModal.vue?vue&type=template&id=1b448ee0&scoped=true"
import script from "./CategoryGroupModal.vue?vue&type=script&lang=js"
export * from "./CategoryGroupModal.vue?vue&type=script&lang=js"

import "./CategoryGroupModal.vue?vue&type=style&index=0&id=1b448ee0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b448ee0"]])

export default __exports__